export default __webpack_public_path__ + "static/media/checked.e3dc6eaa.svg";